import { themeContext } from 'contexts/theme_context/ThemeContext'
import React, { useContext } from 'react'


export default function Loading() {
    let {webtheme}=useContext(themeContext)
  return (
    <div className='col-12 h-100 d-flex justify-content-center align-items-center py-5'>
      <i className={`fa-solid fa-arrows-spin fa-spin ${webtheme}-text`} id='spinner'></i>
    </div>
  )
}
